// Entry point for the portal (public-facing pages) bundle.
// Deliberately excludes Trix/ActionText, bootstrap, mdb-ui-kit, cocoon, and
// admin-only Stimulus controllers — those live in application.js (admin).
import "@hotwired/turbo-rails"
import "./controllers/portal_index"  // eager Stimulus registrations
import "./modal_esc"

import { application } from "./controllers/application"
import { lazyControllers } from "./controllers/lazy_index"

const loaded = new Set()
const loading = new Map()

async function loadController(id) {
  if (loaded.has(id)) return
  const importer = lazyControllers[id]
  if (!importer) return
  if (loading.has(id)) { await loading.get(id); return }
  const p = importer().then((mod) => {
    application.register(id, mod.default)
    loaded.add(id)
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.warn(`[lazy-controllers] failed to load "${id}"`, err)
  }).finally(() => {
    loading.delete(id)
  })
  loading.set(id, p)
  await p
}

function bootLazyControllers() {
  const elements = document.querySelectorAll("[data-controller]")
  const seen = new Set()
  elements.forEach((el) => {
    const tokens = (el.getAttribute("data-controller") || "").trim().split(/\s+/)
    tokens.forEach((id) => {
      if (id && !seen.has(id) && !loaded.has(id) && lazyControllers[id]) {
        seen.add(id)
        loadController(id)
      }
    })
  })
}

document.addEventListener("DOMContentLoaded", bootLazyControllers)
document.addEventListener("turbo:load", bootLazyControllers)
document.addEventListener("turbo:render", bootLazyControllers)

// tw-elements (Offcanvas) — only needed when the user opens the navbar
// drawer. Bind a one-shot handler that lazy-loads the lib, initialises
// it, then opens the drawer via the API on the same gesture.
//
// Why API-not-click: re-dispatching trigger.click() after initTE collides
// with TE's freshly-installed open/outside-dismiss handlers within the
// same event tick, so the drawer opens and immediately closes. Calling
// Offcanvas.getOrCreateInstance(target).show() opens it without firing
// another click event.
function lazyInitTwElementsOffcanvas() {
  const trigger = document.querySelector('[data-te-offcanvas-toggle], [data-bs-toggle="offcanvas"]')
  if (!trigger) return
  const handler = async (event) => {
    if (trigger.dataset.teReady === "1") return
    event.preventDefault()
    event.stopImmediatePropagation()
    trigger.dataset.teReady = "1"
    const targetSelector = trigger.dataset.teTarget || trigger.dataset.bsTarget
    const { Offcanvas, initTE } = await import("tw-elements")
    initTE({ Offcanvas })
    const target = targetSelector && document.querySelector(targetSelector)
    if (target) Offcanvas.getOrCreateInstance(target).show()
  }
  trigger.addEventListener("click", handler, { capture: true })
}

document.addEventListener("DOMContentLoaded", lazyInitTwElementsOffcanvas)
document.addEventListener("turbo:load", lazyInitTwElementsOffcanvas)
